import React, { useEffect, useRef } from 'react';

import * as d3 from 'd3';

export function prepareLineChartWithGap(start, step, data, gapValue = -1) {
  let lines = [];
  let gaps = [];
  let dateBound = { min: start, max: start }
  let valueBound = { min: undefined, max: undefined }

  let inProgressLine = undefined;
  let inProgressGap = undefined;
  for (let i = 0; i < data.length; i++) {
    let value = data[i];
    let date = new Date();
    date.setTime(start.getTime() + (step * i));

    // update bounds
    dateBound.max = date;
    if (value !== gapValue) {
      if (valueBound.min !== undefined)
        valueBound.min = Math.min(valueBound.min, value);
      else
        valueBound.min = value;
      if (valueBound.max !== undefined)
        valueBound.max = Math.max(valueBound.max, value);
      else
        valueBound.max = value;
    }

    if (inProgressLine !== undefined) { // a line is not committed
      if (value === gapValue) { // new gap
        lines.push(inProgressLine);
        inProgressGap = [inProgressLine[inProgressLine.length - 1].x, date];
        inProgressLine = undefined;
      } else { // add to the line
        inProgressLine.push({ x: date, y: value });
      }
    } else if (inProgressGap !== undefined) { // a gap is not committed
      if (value === gapValue) { // add to the gap
        inProgressGap.push(date);
      } else { // new line
        inProgressGap.push(date);
        gaps.push({
          start: inProgressGap[0],
          end: inProgressGap[inProgressGap.length - 1]
        });
        inProgressGap = undefined;
        inProgressLine = [{ x: date, y: value }];
      }
    } else { // we are in the start!
      if (value === gapValue) { // new gap
        inProgressGap = [date];
      } else { // new line
        inProgressLine = [{ x: date, y: value }];
      }
    }
  }

  // finalize
  if (inProgressLine !== undefined) { // a line is not committed
    lines.push(inProgressLine);
    inProgressLine = undefined;
  }
  if (inProgressGap !== undefined) { // a gap is not committed
    gaps.push({
      start: inProgressGap[0],
      end: inProgressGap[inProgressGap.length - 1]
    });
    inProgressGap = undefined;
  }

  // add dots & mark line start/end
  let dots = [];
  let _lines = []
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    if (line.length === 1) {
      dots.push(line[0]);
    } else if (line.length > 1) {
      line[0].itsStart = true;
      line[line.length - 1].itsEnd = true;
      _lines.push(line);
    } else {
      console.log("prepareLineChartWithGap: line.length", line.length);
      // what the hell?
    }
  }
  lines = _lines;

  return [dots, lines, gaps, dateBound, valueBound];
}

export function prepareLineChartWithGapFromTimestampValue(points, gapValue = null) {
  let dots = [];
  let lines = [];
  let gaps = [];
  let dateBound = { min: undefined, max: undefined }
  let valueBound = { min: undefined, max: undefined }
  if (points.length < 2) {
    return [dots, lines, gaps, dateBound, valueBound];
  }
  // console.log("points", points);
  dateBound = { min: points[0][0], max: points[points.length - 1][0] };

  let inProgressLine = undefined;
  let inProgressGap = undefined;
  for (let i = 0; i < points.length; i++) {
    let point = points[i];
    let date = point[0];
    let value = point[1];

    // update bounds
    if (value !== gapValue) {
      if (valueBound.min !== undefined)
        valueBound.min = Math.min(valueBound.min, value);
      else
        valueBound.min = value;
      if (valueBound.max !== undefined)
        valueBound.max = Math.max(valueBound.max, value);
      else
        valueBound.max = value;
    }

    if (inProgressLine !== undefined) { // a line is not committed
      if (value === gapValue) { // new gap
        inProgressLine.push({ x: date, y: inProgressLine[inProgressLine.length - 1].y });
        lines.push(inProgressLine);
        inProgressGap = [date];
        inProgressLine = undefined;
      } else { // add to the line
        inProgressLine.push({ x: date, y: value });
      }
    } else if (inProgressGap !== undefined) { // a gap is not committed
      if (value === gapValue) { // add to the gap
        inProgressGap.push(date);
      } else { // new line
        inProgressGap.push(date);
        gaps.push({
          start: inProgressGap[0],
          end: inProgressGap[inProgressGap.length - 1]
        });
        inProgressGap = undefined;
        inProgressLine = [{ x: date, y: value }];
      }
    } else { // we are in the start!
      if (value === gapValue) { // new gap
        inProgressGap = [date];
      } else { // new line
        inProgressLine = [{ x: date, y: value }];
      }
    }
  }

  // finalize
  if (inProgressLine !== undefined) { // a line is not committed
    lines.push(inProgressLine);
    inProgressLine = undefined;
  }
  if (inProgressGap !== undefined) { // a gap is not committed
    gaps.push({
      start: inProgressGap[0],
      end: inProgressGap[inProgressGap.length - 1]
    });
    inProgressGap = undefined;
  }

  // add dots & mark line start/end
  let _lines = []
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    if (line.length === 1) {
      dots.push(line[0]);
    } else if (line.length > 1) {
      line[0].itsStart = true;
      line[line.length - 1].itsEnd = true;
      _lines.push(line);
    } else {
      console.log("prepareLineChartWithGap: line.length", line.length);
      // what the hell?
    }
  }
  lines = _lines;

  return [dots, lines, gaps, dateBound, valueBound];
}

export function mergeBounds() {
  let finalBound = { min: undefined, max: undefined }
  for (var i = 0; i < arguments.length; i++) {
    if (finalBound.min !== undefined)
      finalBound.min = Math.min(finalBound.min, arguments[i].min);
    else
      finalBound.min = arguments[i].min;
    if (finalBound.max !== undefined)
      finalBound.max = Math.max(finalBound.max, arguments[i].max);
    else
      finalBound.max = arguments[i].max;
  }
  return finalBound;
}

export function PowerChart({
  chartKey, className,
  width, height, margin,
  singlePoints, lines, gaps,
  dateBound, powerBound,
  dateFormatter, powerFormatter, duration }) {
  const chartRef = useRef();

  useEffect(() => {
    // config
    const padding = ({ top: 8, right: 8, bottom: 8, left: 8 });
    const lineList = lines;
    const dataXBound = dateBound;
    const dataYBound = powerBound; // 0, d3.max(data, d => d.y)
    const dcBoxes = gaps;
    const lineWidth = 3;
    let _dateFormatter = dateFormatter.format;

    chartRef.current.innerHTML = "";

    const svg = d3.select(chartRef.current)
      .append("svg").attr("viewBox", [0, 0, width, height])
      .attr("width", width)
      .attr("height", height);

    // background
    svg.append("rect")
      .attr("transform", `translate(${margin.left}, ${margin.top})`)
      .attr("width", width - margin.left - margin.right)
      .attr("height", height - margin.top - margin.bottom)
      .attr("rx", 8)
      .attr("opacity", "0.35")
      .attr("fill", "black");

    let xNiceInterval = undefined;
    switch (duration) {
      case "last30":
        xNiceInterval = d3.timeDay.filter(d => d3.timeDay.count(dataXBound.min, d) % 2 === 0);
        break;
      case "last7":
        xNiceInterval = d3.timeDay.every(1);
        break;
      case "last1":
      default:
        xNiceInterval = d3.timeHour.every(2);
        break;
    }
    const x = d3.scaleTime()
      .domain([dataXBound.min, dataXBound.max]).nice(xNiceInterval)
      .range([padding.left + margin.left, width - margin.right - padding.right]);

    const y = d3.scaleLinear()
      // .domain([dataYBound.min, dataYBound.max]).nice()
      .domain([dataYBound.min, dataYBound.max])
      .range([height - margin.bottom - padding.bottom, margin.top + padding.top]);

    const xAxis = g => g
      .attr("transform", `translate(0,${height - margin.bottom})`)
      .call(
        d3.axisBottom(x)
          .tickSize(-(height - margin.bottom - margin.top))
          .tickFormat(d => _dateFormatter(d))
          .ticks(xNiceInterval))
      .call(g => g.select(".domain").remove())
      .call(g => g.selectAll(".tick").select("line")
        .attr("stroke-opacity", 0.2)
        .attr("stroke-dasharray", "8,4")
      )
      //.attr("transform", "translate(0," + height + ")")
      .attr("color", "white");

    // .call(d3.axisBottom(x).ticks(d3.timeDay, 1).tickFormat(d => dateFormatter(d)))
    // .call(d3.axisBottom(x).tickFormat(d => dateFormatter(d)))

    svg.append("g")
      .call(xAxis);

    const yAxis = g => g
      .attr("transform", `translate(${margin.left},0)`)
      .call(d3.axisLeft(y).ticks(8).tickFormat(p => {
        if (p < 0) return '';
        return powerFormatter(p);
      }))
      .call(g => g.select(".domain").remove())
      .call(g => g.selectAll(".tick").select("line").remove())
      .attr("color", "white");

    svg.append("g")
      .call(yAxis);

    const pattern = svg.append("pattern")
      .attr("id", chartKey + "-chart-bg-pattern")
      .attr("width", 20)
      .attr("height", 10)
      .attr("patternUnits", "userSpaceOnUse")
      .attr("patternTransform", "rotate(-45)");
    pattern.append("rect")
      .attr("fill", "#000000")
      .attr("width", 20)
      .attr("height", 10)
      .attr("x", 0)
      .attr("y", 0);
    pattern.append("line")
      .attr("stroke", "#a6a6a6")
      .attr("stroke-width", 2)
      .attr("y2", 10);

    for (let i = 0; i < dcBoxes.length; i++) {
      const dcBox = dcBoxes[i];
      svg.append("rect")
        .attr("transform", `translate(${x(dcBox.start) + lineWidth / 2}, ${margin.top})`)
        .attr("width", x(dcBox.end) - x(dcBox.start) - lineWidth)
        .attr("height", height - margin.top - margin.bottom)
        .attr("opacity", "0.35")
        .attr("fill", "url(#" + chartKey + "-chart-bg-pattern)");
    }

    svg.append("linearGradient")
      .attr("id", chartKey + "-chart-line-gradient")
      .attr("gradientUnits", "userSpaceOnUse")
      .attr("x1", "50%")
      .attr("y1", "50%")
      .attr("x2", "33%")
      .attr("y2", "91%")
      .selectAll("stop")
      .data([
        { offset: "0%", color: "#74FFF3" },
        { offset: "100%", color: "#00FFA9" }
      ])
      .enter().append("stop")
      .attr("offset", function (d) { return d.offset; })
      .attr("stop-color", function (d) { return d.color; });

    for (let i = 0; i < lineList.length; i++) {
      const lineData = lineList[i];
      const line = d3.line()
        // .curve(d3.curveCardinal)
        // .curve(d3.curveBasis)
        .x(d => x(d.x))
        .y(d => y(d.y));
      svg.append("path")
        .datum(lineData)
        .attr("fill", "none")
        .attr("stroke", "url(#" + chartKey + "-chart-line-gradient)")
        .attr("stroke-width", lineWidth)
        .attr("stroke-linejoin", "round")
        .attr("stroke-linecap", "round")
        .attr("d", line);
    }

    // Add dots
    svg.append('g')
      .selectAll("dot")
      .data(singlePoints)
      .enter()
      .append("circle")
      .attr("cx", d => x(d.x))
      .attr("cy", d => y(d.y))
      .attr("r", lineWidth)
      .style("fill", "url(#" + chartKey + "-chart-line-gradient)")
  }, [chartKey, width, height, margin,
    singlePoints, lines, gaps, dateBound, powerBound,
    dateFormatter, powerFormatter, duration]);


  return (
    <div className={className} ref={chartRef} />
  );
}
